export const choreDisabledTranslateEn = {
    DISABLED_VIEW:{
      TITLE: "Chores just got easier through the app",
      DESCRIPTION: "We're moving chores to our app for a more dynamic and accessible experience for you",
      BUTTON: "Download the Modak App"
    }
  }